(function(){
  if(window.__ocx) return; window.__ocx=true;
  var rm=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countUp(dt){
    var f=dt.getAttribute('data-count'),x=f&&f.match(/^(.*?)(\d[\d,]*\.?\d*)(.*)$/);
    if(!x||rm){if(f)dt.textContent=f;return;}
    var raw=x[2].replace(/,/g,''),n=parseFloat(raw),dec=(raw.split('.')[1]||'').length,comma=x[2].indexOf(',')>-1,t0=null;
    function fmt(v){var s=v.toFixed(dec);return comma?Number(s).toLocaleString('en-US',{minimumFractionDigits:dec,maximumFractionDigits:dec}):s;}
    function step(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/1000,1),e=1-Math.pow(1-p,3);dt.textContent=x[1]+fmt(n*e)+x[3];if(p<1)requestAnimationFrame(step);else dt.textContent=f;}
    requestAnimationFrame(step);
  }
  function countIn(scope){scope.querySelectorAll('[data-count]').forEach(function(d){if(d.offsetParent!==null)countUp(d);});}
  function init(root){
    root=root||document;
    var io='IntersectionObserver' in window?new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');if(e.target.hasAttribute('data-counts'))countIn(e.target);io.unobserve(e.target);}})},{threshold:.15,rootMargin:'0px 0px -40px 0px'}):null;
    root.querySelectorAll('.ocx [data-r]:not(.is-in)').forEach(function(e){io?io.observe(e):e.classList.add('is-in');});
    root.querySelectorAll('[data-ocx-markets]').forEach(function(sec){
      if(sec.__ok)return;sec.__ok=true;
      var btns=[].slice.call(sec.querySelectorAll('[data-set]')),bar=sec.querySelector('.ocx-mk__bar'),ok=btns.map(function(b){return b.getAttribute('data-set')}),seen=false;
      function move(){var on=sec.querySelector('[data-set].is-on');if(bar&&on){bar.style.width=on.offsetWidth+'px';bar.style.transform='translateX('+on.offsetLeft+'px)';}}
      function set(m,push){
        if(ok.indexOf(m)<0)return;sec.setAttribute('data-market',m);
        btns.forEach(function(b){var on=b.getAttribute('data-set')===m;b.classList.toggle('is-on',on);b.setAttribute('aria-selected',on);});
        move();if(seen)countIn(sec);
        if(push){try{var u=new URL(location.href);u.searchParams.set('market',m);history.replaceState(null,'',u);}catch(e){}}
      }
      btns.forEach(function(b){b.addEventListener('click',function(){set(b.getAttribute('data-set'),true);});});
      var q=(new URLSearchParams(location.search).get('market')||'').toLowerCase();
      set(ok.indexOf(q)>-1?q:sec.getAttribute('data-market'),false);
      window.addEventListener('resize',move);if(document.fonts&&document.fonts.ready)document.fonts.ready.then(move);
      if('IntersectionObserver' in window){var so=new IntersectionObserver(function(en){if(en[0].isIntersecting){seen=true;countIn(sec);so.disconnect();}},{threshold:.25});so.observe(sec.querySelector('.ocx-stats')||sec);}else seen=true;
    });
    root.querySelectorAll('[data-ocx-open]').forEach(function(b){
      if(b.__ok)return;b.__ok=true;
      b.addEventListener('click',function(e){var d=document.getElementById(b.getAttribute('data-ocx-open'));if(!d||!d.showModal)return;e.preventDefault();d.showModal();var v=d.querySelector('video');if(v){try{v.play();}catch(err){}}});
    });
    root.querySelectorAll('.ocx-modal').forEach(function(d){
      if(d.__ok)return;d.__ok=true;
      d.addEventListener('click',function(e){if(e.target===d)d.close();});
      var c=d.querySelector('[data-close]');if(c)c.addEventListener('click',function(){d.close();});
      d.addEventListener('close',function(){var v=d.querySelector('video');if(v)v.pause();});
    });
    var qs=new URLSearchParams(location.search);
    root.querySelectorAll('.ocx-form').forEach(function(f){
      ['utm_source','utm_medium','utm_campaign','utm_content'].forEach(function(k){var i=f.querySelector('[data-utm="'+k+'"]');if(i)i.value=qs.get(k)||'';});
      var p=f.querySelector('[data-page-url]');if(p)p.value=location.href.split('#')[0];
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init();});else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();